import { LocalStorage } from '@hotjar/insights-common/lib/storage-factory';
import { Store } from '../../../store/player/types';

/**
 * Show the worth watching tooltip once
 */
export const showWorthWatchingTooltipIfNotSeen = (store: Store): void => {
  const { setOpenWorthWatchingTooltip, setOpenWorthWatchingTooltipCountdown } = store.getState();

  const localStorageKey = 'worthWatchingTooltipSeen';
  if (!LocalStorage.get(localStorageKey)) {
    // Due to the hacky way we can control the tooltip (See ThumbsUpDownTooltip component for more info)
    // It only reacts to a change of value
    setOpenWorthWatchingTooltip(false);
    setOpenWorthWatchingTooltipCountdown(+setTimeout(() => setOpenWorthWatchingTooltip(true), 500));
    LocalStorage.set(localStorageKey, true);
  }
};
